import {
  assignMaterialToCompany,
  assignMaterialToDepartment,
  assignMaterialToUser,
  getWellbeingMaterials,
} from "../../repository/data.repository";
import { createSearchRequest } from "../../hooks/useSearchRequest";
import AssignEntityFormDialog from "../AssignEntityFormDialog";

export interface AssignMaterialFormDialogProps {
  readonly open?: boolean;
  readonly onFinish?: () => void;
  readonly onCancel?: () => void;
}

// Thin wrapper over the shared AssignEntityFormDialog: a material picker + an Is Required toggle,
// fanned out to the company/department/user material-assignment endpoints.
function AssignMaterialFormDialog(props: AssignMaterialFormDialogProps) {
  return (
    <AssignEntityFormDialog
      open={props.open}
      title="Assign Material"
      entityField="material"
      closeOnSuccess
      // Material company assignments cascade to sub-companies, so the reach preview counts them too.
      previewIncludesSubCompanies
      helper="Assign this material to one or more companies, departments, or users. A company assignment also reaches its sub-companies. Mark it Required for material a user must engage with."
      entityControls={[
        {
          type: "combobox",
          label: "Material",
          name: "material",
          request: createSearchRequest(getWellbeingMaterials, "name"),
          rules: [{ required: true, message: "Material is required" }],
          tooltip: "The material to assign to the selected targets.",
        },
        {
          type: "togglebox",
          label: "Is Required",
          name: "isRequired",
          checkedText: "Required",
          unCheckedText: "Optional",
          tooltip:
            "Required = the user must engage with this material. Optional = recommended only.",
        },
      ]}
      assignFns={{
        company: (companyUid, v) =>
          assignMaterialToCompany(v.material.value, companyUid, !!v.isRequired),
        department: (departmentUid, v) =>
          assignMaterialToDepartment(
            v.material.value,
            departmentUid,
            !!v.isRequired,
          ),
        user: (userUid, v) =>
          assignMaterialToUser(v.material.value, userUid, !!v.isRequired),
      }}
      onFinish={props.onFinish}
      onCancel={props.onCancel}
    />
  );
}

export default AssignMaterialFormDialog;
